// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite24: FC<Favorite24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M18.073 5.225c-.816-.29-1.71-.3-2.534-.029h-.002c-.85.28-1.484 1.038-1.926 1.905a7.223 7.223 0 0 0-.566 1.537l-.005.017v.002c-.096.47-.532.81-1.04.81-.476 0-.89-.3-1.019-.725l-.022-.087-.004-.018a6.296 6.296 0 0 0-.118-.43 7.201 7.201 0 0 0-.447-1.106c-.442-.867-1.076-1.626-1.928-1.905a3.93 3.93 0 0 0-2.535.029c-.539.19-1.127.514-1.58 1.062-.442.534-.817 1.353-.82 2.647v.002a2.43 2.43 0 0 0 .041.29c.046.228.144.58.348 1.022.407.877 1.25 2.135 3.015 3.472a31.978 31.978 0 0 1 4.43 4.06c.239.264.45.508.633.726.165-.198.354-.418.567-.655.971-1.085 2.45-2.556 4.504-4.128l.32-.251c1.543-1.251 2.31-2.41 2.693-3.233.206-.44.305-.793.352-1.02.024-.114.035-.198.04-.245l.004-.044v-.002c-.005-1.29-.38-2.107-.82-2.64-.454-.547-1.041-.872-1.581-1.064Zm3.46 3.726 1.059.01v.012l-.001.016a2.478 2.478 0 0 1-.013.179c-.01.109-.031.257-.069.437-.075.362-.22.855-.492 1.44-.514 1.102-1.473 2.502-3.251 3.943l-1.068.84a30.168 30.168 0 0 0-3.52 3.314c-.448.5-.774.905-.984 1.181-.106.138-.182.244-.231.313l-.052.075-.011.016h-.001l-.88 1.338-.908-1.32c0-.002 0-.003-.002-.004l-.013-.018-.059-.083c-.055-.075-.14-.188-.253-.334a22.823 22.823 0 0 0-1.037-1.232 29.912 29.912 0 0 0-4.143-3.795c-2.024-1.534-3.082-3.05-3.628-4.23a6.597 6.597 0 0 1-.488-1.446 4.314 4.314 0 0 1-.078-.575l-.002-.045v-.027l1.06-.005-1.06.004v-.004c0-1.696.502-2.968 1.27-3.895.757-.916 1.713-1.424 2.506-1.704a6.164 6.164 0 0 1 3.974-.044c1.379.452 2.276 1.468 2.842 2.394.566-.926 1.464-1.942 2.842-2.394l.243-.075a6.166 6.166 0 0 1 3.49.038l.241.08.002.002c.79.28 1.747.788 2.505 1.704.767.927 1.269 2.198 1.269 3.894v.01l-1.06-.01Z" />
        </svg>
    );
};

export default Favorite24;
